function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="16" height="14" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg" {...props}><defs /><title>icons</title><g id="VR-Demo----Desktop" fill="none" fillRule="evenodd"><g id="1056_VR_Demo_Custom_Model_How-to-train-02.1" transform="translate(-527 -508)"><g id="arrow--right-copy-15" transform="matrix(-1 0 0 1 544 505)"><g id="Icon" transform="translate(1.25 3.75)" fill="#d8d8d8" fillRule="nonzero"><path id="Shape" d="M9.375 0l-.881.881 4.737 4.744H0v1.25h13.231l-4.737 4.744.881.881 6.25-6.25z" /></g></g></g></g></svg>;
});


// WEBPACK FOOTER //
// ./src/images/arrow-left.svg